export default "__VITE_ASSET__CESz3Y_O__"